import React from 'react';

import { defaultTo, prop } from 'ramda';

import icon from '../../../images/screening_questionnaire.png';

import { FOHImage } from '..';

export const FOHQuestionnaireIcon = (props: any) => (
  <FOHImage
    source={{ uri: icon }}
    style={{ width: 90, height: 68, ...defaultTo({}, prop('style', props)) }}
  />
);
